import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const UseBook = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('instruction_use_book_base'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])

    return <div className="App">
        <div className="bind-device-faq-marginH20">
            <img src={`${CommonUtil.getSourceDomain()}use_book.png`} alt="" style={{ width: '100%', marginTop: 15 }} />
        </div>
        <div style={{ height: 40 }} />
    </div>
}

export default UseBook